<template>
  <div>
    <div v-if="!isFormSubmitted">
      <div class="form-group lead mb-2">
        {{ title }}
      </div>
      <form class="form-inline rounded pt-2 pb-2" method="post" name="subscription" netlify @submit.prevent="handleSubmit">
        <div class="flex-fill d-flex flex-nowrap">
          <div class="form-group mr-3 mb-2 flex-fill">
            <input type="email" class="form-control w-100" placeholder="E-mail" size="28" required v-model="email">
          </div>
          <button type="submit" class="btn btn-theme mb-2">Subscribe&nbsp;→</button>
        </div>
        <span class="ml-md-3 mb-2">
          By submitting the form, you accept <br/><router-link style="text-decoration: underline" :to="{name: 'privacy'}">Privacy Policy</router-link> of this website.
        </span>
      </form>
    </div>
    <div v-else class="d-flex align-items-center">
      <Success class="mr-2" />
      <h4 class="mb-0 mt-1">Thank you! You have been subscribed</h4>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Success from '../elements/Success'

export default {
  name: 'MainSubscribe',
  data() {
    return {
      email: '',
      isFormSubmitted: false,
      errorText: ''
    }
  },
  components: {
    Success
  },
  methods: {
    encode(data) {
      return Object.keys(data)
        .map(
          key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
        )
        .join('&')
    },
    handleSubmit() {
      axios.post(
        window.location.href,
        this.encode({
          'form-name': 'subscription',
          email: this.email
        }),
        { header: { 'Content-Type': 'application/x-www-form-urlencoded' } }
      ).then(() => {
        this.isFormSubmitted = true
        this.email = ''
        this.errorText = ''
      }).catch(err => {
        this.errorText = `Something went wrong. Please try again ${err}`
      })
    }
  },
  props: {
    title: {
      type: String,
      default: 'Subscribe'
    }
  }
}
</script>
